export default "__VITE_ASSET__DNr9eEIx__"